import React from 'react';
var ThemeContext = /*#__PURE__*/React.createContext('light');
export default ThemeContext;